import { render, staticRenderFns } from "./college.vue?vue&type=template&id=4187bcd4&scoped=true"
import script from "./college.vue?vue&type=script&lang=js"
export * from "./college.vue?vue&type=script&lang=js"
import style0 from "./college.vue?vue&type=style&index=0&id=4187bcd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187bcd4",
  null
  
)

export default component.exports